<!--
  @修改人：黎柏祺
  @修改时间：2018-10-28
  @修改描述：框架升级
  @版本:v1.0.26
  ------------
  @负责人：libaiqi
  @创建日期：2018-9-18
  @版本号：V1.0.21
  @描述： 程序包配置
-->
<style>
.packageConfig__content .packageConfig__tag{
  cursor:pointer;
}
.packageConfig__card{
  margin:20px 0;
}
.packageConfig__card .box-card .box-card__line{
  margin-bottom:15px;
}
.packageConfig__card .box-card .box-card__lable{
  display:inline-block;
  width:100px;
}
.packageConfig__card .box-card .box-card__text{
  display:inline-block;
  width:200px;
}
</style>

<template>
  <div class="packageConfig__content">
    <back :history="history"></back>
    <div class="packageConfig__operation">
      <el-button type="primary"  @click="e_createVersion">{{ $t('packageManage.createVersion') }}</el-button>
      <el-button type="danger"  @click="e_delete" v-g-rac="gRac('programPackage@deleteRelease')">{{ $t('packageManage.delete') }}</el-button>
    </div>
    <div class="packageConfig__card">
      <el-card class="box-card">
        <div class="box-card__line">
          <span class="box-card__lable">{{ $t('packageManage.creator') }}：</span>
          <span class="box-card__text">{{creator}}</span>
          <span class="box-card__lable">{{ $t('packageManage.buildPath') }}：</span>
          <span class="box-card__text">{{buildPath}}</span>
        </div>
        <div>    
          <span class="box-card__lable">{{ $t('packageManage.os') }}：</span>
          <span class="box-card__text">{{os}}</span>
          <span class="box-card__lable">{{ $t('packageManage.desc') }}：</span>
          <span class="box-card__text">{{desc}}</span>
        </div>
      </el-card>
    </div>
    <div class="packageConfig__form">
       <el-form ref="form" :model="form" :inline="true" label-width="0">
        <el-form-item>
          <el-input v-model="form.version" prefix-icon="uk-icon-search" :placeholder="$t('packageManage.searchVersion')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="login-btn" @click="e_search" v-g-rac="gRac('programPackage@searchRelease')">{{ $t('packageManage.search') }}</el-button>
        </el-form-item>
      </el-form>      
    </div>
    <div class="packageConfig__table">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="storeSelection">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
          prop="group"
          :label="$t('packageManage.table.group')"
          >
        </el-table-column>
        <el-table-column
          prop="version"
          :label="$t('packageManage.table.version')"
          >
          <template slot-scope="scope">
            <div class="packageConfig__tag" @click="skipToVersionPage(scope.row)">
              <el-button type="text" size="small">{{ scope.row.version }}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('packageManage.table.type')"
          :formatter="formatType"
          >
        </el-table-column>
        <el-table-column
          prop="creator"
          :label="$t('packageManage.table.creator')"
          >
        </el-table-column>
        <el-table-column
          prop="createTime"
          :formatter="formatTime"
          :label="$t('packageManage.table.createTime')"
          >
        </el-table-column>
        <el-table-column
          :label="$t('common.handle')"
          width="100">
          <template slot-scope="scope">
            <el-button @click="cloneVersion(scope.row)" type="text" size="small">{{ $t('packageManage.clone') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="el-table-extend__pager">
        <el-pagination
          background
          @size-change="sizeChange"
          @current-change="currentChange"
          layout="total, sizes, prev, pager, next, jumper"        
          :current-page="currentPage"
          :page-size="pageSize"
          :page-count="pageCount"
          :total="total"
          >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>

import packageManageBiz from '@/logic/continuousDelivery/programPackageManageBiz.js'
import back from '@/components/back'
import dic from '@/components/mixins/dic'
import rac from '@/plugins/rac-mixin.js'
import TimeFormat from '@/utils/timeFormat.js'

export default {
  mixins: [dic, rac],
  data () {
    return {
      form: {
        version: ''
      },
      creator: '',
      os: '',
      buildPath: '',
      desc: '',
      currentPage: 1,
      pageSize: 10,
      pageCount: 0,
      total: 0,
      tableData: [],
      multipleSelection: [],
      history: [],
      typeList: {}
    }
  },
  methods: {
    e_init () {
      const that = this
      packageManageBiz.getAppPackage({ id: that.$route.query.pkId }).then((d) => {
        that.creator = d.creator
        that.buildPath = d.deployPath
        that.os = d.os
        that.desc = d.desc
        that.history = []
        that.history.push({ name: that.$t('packageManage.packageManage') })
      })
      this.waitAppPackageType()
    },
    async waitAppPackageType () {
      await this.dGetDictionaryByCode('appPackageType')
      this.typeList = { ...this.dDictionary.appPackageType }
    },
    search (data) {
      let d = {
        currentPage: 1,
        perPageCount: 10,
        packageName: this.$route.query.packageName,
        ...data
      }
      packageManageBiz.findRelease(d).then((data) => {
        this.tableData = data.dataList
        this.total = data.totalCount
        this.pageCount = data.totalPageCount
      }).catch((err) => {
        console.error(err)
      })
    },
    currentChange (data) {
      this.search({
        currentPage: data
      })
    },
    sizeChange (data) {
      this.search({
        perPageCount: data
      })
    },
    storeSelection (data) {
      this.multipleSelection = data
    },
    e_search () {
      let d = {
        version: this.form.version
      }
      this.search(d)
    },
    e_createVersion () {
      let query = {}
      query.pkId = this.$route.query.pkId
      query.packageName = this.$route.query.packageName
      query.from = 'packageConfig'
      this.$router.push({ path: '/home/programPackageManage/createVersion', query: query })
    },
    e_delete () {
      const that = this
      if (that.multipleSelection.length === 0) {
        that.$message({
          message: that.$t('packageManage.rules.delete'),
          type: 'warning'
        })
        return
      }
      that.$confirm(that.$t('common.deleteTips'), that.$t('common.delete'), {
        confirmButtonText: that.$t('common.confirm'),
        cancelButtonText: that.$t('common.cancel'),
        type: 'warning'
      }).then(() => {
        let ids = []
        that.multipleSelection.forEach((item) => {
          ids.push(item.id)
        })
        packageManageBiz.deleteRelease({ ids: ids }).then(() => {
          that.$message({
            message: that.$t('packageManage.success'),
            type: 'success'
          })
          setTimeout(() => {
            that.search()
          }, 500)
        })
      }).catch(() => {})
    },
    formatTime (row, column) {
      return TimeFormat.getFormatTime(row.createTime, 'yyyy-mm-dd hh-MM-ss')
    },
    formatType (row, column) {
      return this.typeList[row.type]
    },
    skipToVersionPage (row) {
      let query = {}
      query.pkId = this.$route.query.pkId
      query.packageName = this.$route.query.packageName
      query.from = 'packageConfig'
      query.version = row.version
      this.$router.push({ path: '/home/programPackageManage/createVersion', query: query })
    },
    cloneVersion (info) {
      let query = {}
      query.pkId = this.$route.query.pkId
      query.packageName = this.$route.query.packageName
      query.from = 'packageConfig'
      query.version = info.version
      query.isClone = '1'
      this.$router.push({ path: '/home/programPackageManage/createVersion', query: query })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.e_init()
      this.search()
    })
  },
  components: {
    back
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'packageConfig' && (from.name === 'programPackageManage' || from.name === 'createVersion')) {
        this.packageName = this.$route.query.packageName
        const that = this
        packageManageBiz.getAppPackage({ id: that.$route.query.pkId }).then((d) => {
          that.creator = d.creator
          that.buildPath = d.deployPath
          that.os = d.os
          that.desc = d.desc
          that.history = []
          that.history.push({ name: that.$t('packageManage.packageManage') })
        })
        this.search()
      }
    }
  }
}
</script>
